<template>
  <div class="form-item__row">
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Google Click ID</span>
        <p class="form-control">
          {{ source.gclid | nullable }}
        </p>
      </div>
    </div>
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Source</span>
        <p class="form-control">
          {{ source.campaign_source | nullable }}
        </p>
      </div>
    </div>
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Name</span>
        <p class="form-control">
          {{ source.campaign_name | nullable }}
        </p>
      </div>
    </div>
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Medium</span>
        <p class="form-control">
          {{ source.campaign_medium | nullable }}
        </p>
      </div>
    </div>
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Content</span>
        <p class="form-control">
          {{ source.campaign_content | nullable }}
        </p>
      </div>
    </div>
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Sendgrid Stage</span>
        <p class="form-control">
          {{ source.sendgrid_stage | nullable }}
        </p>
      </div>
    </div>
    <div class="form-item__field">
      <div class="input-group input-group-booking-detail">
        <span class="input-group-addon">Existing User</span>
        <p class="form-control">
          {{ source.existing_user | nullable }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      required: true,
      type: Object
    }
  }
}
</script>
